export const TRUCKS_ENDPOINTS = {
  GET: (emsAgencyId: String) => `/v4/emsAgencies/${emsAgencyId}/trucks`,
};
